import React from "react"
import { renderToStaticMarkup } from "react-dom/server"
import { materialIconLoaders } from "./materialIconsLoaders"

// currentColor is resolved from the CSS `color` property, so it works even outside the DOM
export const buildTintedIconSvg = async (iconName, hexColor) => {
  const mod = await materialIconLoaders[iconName]()
  const IconComponent = mod.default
  const markup = renderToStaticMarkup(<IconComponent />)
  // renderToStaticMarkup omits xmlns since it assumes an HTML parent to inherit the SVG
  // namespace from — required here since the markup is exported as a standalone .svg file.
  // fill="currentColor" is also required: the app normally gets it from the .MuiSvgIcon-root
  // CSS class, which doesn't exist in this standalone export, so the path defaults to black.
  return markup.replace(
    "<svg ",
    `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" style="color:${hexColor}" `
  )
}
